<div class="layout-main">
  <router-outlet></router-outlet>
</div>